const SELECTOR = '.js-expanding-text';
const CONTENT_SELECTOR = '.js-expanding-text_content';
const BUTTON_SELECTOR = '.js-expanding-text_button';
const LABEL_SELECTOR = '.js-expanding-text_label';
const OPEN_ICON_SELECTOR = '.js-expanding-text_open-icon';
const CLOSE_ICON_SELECTOR = '.js-expanding-text_close-icon';
const MAX_LINES_ATTR = 'data-max-lines';
const READ_MORE_ATTR = 'data-read-more-label';
const READ_LESS_ATTR = 'data-read-less-label';
const CLAMPED_CLASS = 'is-clamped';
const DEFAULT_LINES = 3;
class ExpandingText {
    constructor(root) {
        this.isExpanded = false;
        this.checkOverflow = () => {
            const wasExpanded = this.isExpanded;
            this.applyClamp();
            const clampedHeight = this.content.clientHeight;
            this.removeClamp();
            const fullHeight = this.content.scrollHeight;
            if (!wasExpanded) {
                this.applyClamp();
            }
            this.button.style.display = fullHeight <= clampedHeight ? 'none' : '';
        };
        this.onResize = () => {
            this.checkOverflow();
        };
        this.content = root.querySelector(CONTENT_SELECTOR);
        this.button = root.querySelector(BUTTON_SELECTOR);
        this.label = root.querySelector(LABEL_SELECTOR);
        this.openIcon = root.querySelector(OPEN_ICON_SELECTOR);
        this.closeIcon = root.querySelector(CLOSE_ICON_SELECTOR);
        this.maxLines = parseInt(root.getAttribute(MAX_LINES_ATTR) || String(DEFAULT_LINES), 10);
        this.readMoreLabel = root.getAttribute(READ_MORE_ATTR) || 'Read more';
        this.readLessLabel = root.getAttribute(READ_LESS_ATTR) || 'Read less';
        this.content.style.setProperty('--max-lines', String(this.maxLines));
        this.checkOverflow();
        this.button.addEventListener('click', () => this.toggle());
        window.addEventListener('resize', this.onResize);
    }
    applyClamp() {
        this.content.classList.add(CLAMPED_CLASS);
    }
    removeClamp() {
        this.content.classList.remove(CLAMPED_CLASS);
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
        if (this.isExpanded) {
            this.removeClamp();
            this.label.textContent = this.readLessLabel;
            this.openIcon.style.display = 'none';
            this.closeIcon.style.display = '';
        }
        else {
            this.applyClamp();
            this.label.textContent = this.readMoreLabel;
            this.openIcon.style.display = '';
            this.closeIcon.style.display = 'none';
        }
    }
    destroy() {
        window.removeEventListener('resize', this.onResize);
    }
    static init(selector = SELECTOR) {
        document.querySelectorAll(selector).forEach(root => {
            new ExpandingText(root);
        });
    }
}
export default ExpandingText;
